import { render, staticRenderFns } from "./RangeOfMotionRomInput.vue?vue&type=template&id=2065adf2&scoped=true&"
import script from "./RangeOfMotionRomInput.vue?vue&type=script&lang=ts&"
export * from "./RangeOfMotionRomInput.vue?vue&type=script&lang=ts&"
import style0 from "./RangeOfMotionRomInput.vue?vue&type=style&index=0&id=2065adf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2065adf2",
  null
  
)

export default component.exports